import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { Tema } from '../tema.model';
import { TemaService } from '../tema.service';

@Component({
    selector: 'lib-tema-configuracao-card',
    templateUrl: './tema-configuracao-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemaConfiguracaoCardComponent implements OnDestroy {

    public temaSelecionado: Tema = this.temaService.temaAtual;
    public salvando = false;
    private subscription: Subscription;

    constructor(
        private temaService: TemaService,
        private notificationService: NotificationService,
        private changeDetector: ChangeDetectorRef
    ) {
        // Acompanha o tema aplicado (ex.: resposta da API que chega depois da página abrir).
        this.subscription = this.temaService.tema$.subscribe(tema => {
            this.temaSelecionado = tema;
            this.changeDetector.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    // Salva ao clicar na opção; apenas falhas são notificadas.
    public selecionar(tema: Tema): void {
        this.temaSelecionado = tema;
        this.salvando = true;
        this.temaService.salvar(tema).subscribe(sucesso => {
            this.salvando = false;
            if (!sucesso) {
                this.temaSelecionado = this.temaService.temaAtual;
                this.notificationService.openError('Não foi possível salvar o tema.');
            }
            this.changeDetector.markForCheck();
        });
    }
}
